import React, { useState } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { FaCity } from "react-icons/fa";

const CompanyInformation = ({ data }) => {
  const [company, setCompany] = useState(data);
  const [isEditing] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCompany({ ...company, [name]: value });
  };

  return (
    <div className={styles.LealtadinformacionPersonal} id="personal">
      <h2 className={styles.LealtadsectionTitle}>Información de la Empresa</h2>

      {!company ? (
        <NotReportViewData title="Información de la Empresa" Icon={FaCity} />
      ) : (
        <>
          <div className={styles.Lealtadnad}>
            <label className={styles.LealtadinputLabel}>
              Razón social:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="nombre"
                value={company.companyName || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Cuit:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="cuil"
                value={company.cuit || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Años:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="age"
                value={company.age || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>

          <div className={styles.Lealtadnad}>
            <label className={styles.LealtadinputLabel}>
              Teléfono:
              <input
                className={styles.LealtadinputField}
                type="tel"
                name="telefono"
                value={company.phone || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Correo electrónico:
              <input
                className={styles.LealtadinputField}
                type="email"
                name="correo_electronico"
                value={company.email || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Codigo de actividad laboral:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="codeOfWorkActivity"
                value={company.codeOfWorkActivity || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>

          <div className={styles.Lealtadnad}>
            <label className={styles.LealtadinputLabel}>
              Calle:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="street"
                value={company.street || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Numero:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="numberStreet"
                value={company.numberStreet || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Codigo postal:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="postalCode"
                value={company.postalCode || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>

          <div className={styles.Lealtadnad}>
            <label className={styles.LealtadinputLabel}>
              Localidad:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="location"
                value={company.location || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Provincia:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="province"
                value={company.province || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Pais de residencia:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="nacionality"
                value={company.nacionality || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
          <div className={styles.Lealtadnad}>
            <label className={styles.LealtadinputLabel}>
              Piso:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="floor"
                value={company.floor || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Departamento:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="apartment"
                value={company.apartment || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Actividad que desarrolla:
              <textarea
                className={styles.LealtadinputField}
                type="text"
                name="ActivityBeingCarriedOut"
                value={company.ActivityBeingCarriedOut || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
        </>
      )}
    </div>
  );
};

export default CompanyInformation;
